import React from 'react';
import {
  Column,
  Copy,
  Flex,
  Row,
  Squish,
  Stack,
  Link,
} from '@grubhubprod/gh-cookbook-react';
import { Control } from 'react-hook-form';
import { DeprecatedCookbookCheckboxWrapper } from 'src/components/DeprecatedCookbookCheckboxWrapper/DeprecatedCookbookCheckboxWrapper';
import { IGroup } from 'src/utilities/useSearchHooks';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

export interface AddGroupsToLocItemProps {
  corpId: string;
  group: IGroup;
  control: Control;
  isAssigned: boolean;
}

export const AddGroupsToLocItem: React.FC<AddGroupsToLocItemProps> = ({
  corpId,
  group,
  control,
  isAssigned,
}) => {
  const { isDesktop } = useScreenSizes();

  const isDisabled = isAssigned || !group.diner_count;

  return (
    <Stack key={group.id}>
      <Squish
        as="li"
        inset={isDesktop ? 'lg' : 'md'}
        borderBottom="1px solid"
        borderColor="lightLine"
      >
        <Row>
          <Column phone={1}>
            <Flex
              alignItems="center"
              height="100%"
              className="cancelMarginCheckboxLabel"
            >
              <DeprecatedCookbookCheckboxWrapper
                disabled={isDisabled}
                control={control}
                name="selectedGroupIds"
                id={`selectedGroupIds${group.id}`}
                aria-label={`select group ${group.name}`}
                value={group.id}
              />
            </Flex>
          </Column>
          <Column phone={11}>
            <Row>
              <Column desktop={6}>
                <Flex alignItems="center" height="100%">
                  <div className="ellipsisOverflow">
                    <Copy
                      variant="body"
                      color={isDisabled ? 'globals.stone20a' : 'primaryText'}
                    >
                      {group.name}
                    </Copy>
                  </div>
                </Flex>
              </Column>
              <Column desktop={6}>
                <Flex alignItems="center" height="100%">
                  <Stack className="ellipsisOverflow">
                    {group.diner_count ? (
                      <Copy
                        variant="body"
                        color={isAssigned ? 'globals.stone20a' : 'primaryText'}
                      >
                        {`${group.diner_count} people`}
                      </Copy>
                    ) : (
                      <>
                        <Copy variant="body" color="globals.stone20a">
                          No people in group.{' '}
                        </Copy>
                        <Link
                          href={`/corporate/management/${corpId}/groups/${group.id}`}
                        >
                          Add people
                        </Link>
                      </>
                    )}
                  </Stack>
                </Flex>
              </Column>
            </Row>
          </Column>
        </Row>
      </Squish>
    </Stack>
  );
};
